<template>
  <div class="gameplan">
      <div v-if="!item.themeStylesSecond||item.themeStylesSecond.length==0" class="no_data_tip">
        请选择活动级别后进行配置！
      </div>
      <el-tabs v-else v-model="activeName" tab-position="left" style="height: 100%;">
        <el-tab-pane :label="itemChild.themeLevelName" :name="itemChild.themeLevelName" v-for="(itemChild,index) of item.themeStylesSecond"  :key="itemChild.themeLevelName">
          <ConfigDetailHq ref="configDetailRef" @handleSubmit="handleSubmit" :levelIndex="(index+itemChild.themeLevelName)" :baseConfig="itemInfo" :themeStyles1="itemChild||item" :styleInfo="item"
            :secondTabItemName="itemChild.themeLevelName" :fullConfig="fullConfig" :assignBuList="assignBuList" :assignRegionList="assignRegionList"
            :saveDetailList="itemChild.otherInfo||{isEmpty:true}" :assignAreaList="assignAreaList" @handleStyleAssignChange="handleStyleAssignChange"
            :styleAssignList="styleAssignList" :needTransitions="needTransitions"></ConfigDetailHq>
        </el-tab-pane>
      </el-tabs>
  </div>
</template>

<script>
import ConfigDetailHq from './config-detail-hq.vue'
export default {
  name: 'cross-channel-pop',
  components: {
    ConfigDetailHq,
  },
  data() {
    return {
      //itemInfo: {},
      params: {
        themeStyles: []
      },
      secondActiveName: '',
      themeStyles: [],
      themeStylesValid: [],
      themeStylesValidOrder: [],
      themeStylesSecond: [],
      themeStylesSecondValid: [],
      a:[],
      editRules:{
        themeStyles: [{ required: true, message: "请选择活动形式", trigger: "blur" }],
        themeDecorateCodes: [{ required: true, message: "请选择装饰点位", trigger: "blur" }],
      },
      itemCount:0,
      btnType:'',
      showError:false,
      needTransitions:0,
      styleAssignList:[],
      activeName:''
    }
  },
  props: {
    configItem: { type: Object, default: () => { } },
    fullConfig: { type: Array, default: () => [] },
    assignBuList: { type: Array, default: () => [] },
    assignRegionList: { type: Array, default: () => [] },
    assignAreaList:{ type: Array, default: () => [] },
    detailList: { type: Array, default: () => [] },
    saveDetailList: { type: Array, default: () => [] },
    item:{ type: Object, default: () => { } },
    itemInfo:{ type: Object, default: () => { } },
  },
  watch: {
    'item.themeStylesSecond':{
      handler:function(cur){
        this.activeName = this.item.themeStylesSecond&&this.item.themeStylesSecond[0]&&this.item.themeStylesSecond[0].themeLevelName||''
        // if(this.getLevelIndex!=0&&!this.showSaveAssignList){
        //   this.submitAssignList = cur.map(item=>{
        //     return item
        //   })
        // }
      },
      immediate:true,
      deep:true,
    }
  },
  created() {
  },
  mounted(){
    this.activeName = this.item.themeStylesSecond&&this.item.themeStylesSecond[0]&&this.item.themeStylesSecond[0].themeLevelName||''
  },
  computed:{
    getConfigTitle(){
      return this.itemInfo.themeChannelEnName+"渠道设置"
    },
  },
  methods: {
    handleActivityFormChange() {
      this.secondActiveName = this.themeStylesValidOrder[0] && this.themeStylesValidOrder[0].themeStyleName
    },
    handleThemeStylesValidOrder(){
      this.themeStylesValidOrder=[]
      for(let i of this.itemInfo.themeStyles){
        for(let selected of this.themeStylesValid){
          if(i.themeStyleName===selected.themeStyleName){
            this.themeStylesValidOrder.push(selected)
          }
        }
      }
      //console.log(this.themeStylesValidOrder);
    },
    submit(type){
      this.btnType = type
      this.itemCount=0
      if(this.$refs.configDetailRef&&this.$refs.configDetailRef.length>0){
        for(let i=0;i<this.$refs.configDetailRef.length;i++){
          this.$refs.configDetailRef[i].submit(type)
        }
      }
    },
    isChecked(item) {
      return this.themeStyles.indexOf(item) !== -1
    },
    changeThemeStyles(item) {
      let isChecked = this.isChecked(item.themeStyleName)
      if (isChecked) {
        //if (!item.themeLevels || item.themeLevels.length == 0) {
          this.themeStylesValid.splice(this.themeStylesValid.length, 0, item)
        //}
      } else {
        for (let i = 0; i < this.themeStylesValid.length; i++) {
          if (this.themeStylesValid[i].themeStyleName === item.themeStyleName) {
            this.themeStylesValid.splice(i, 1)
          }
        }
      }
      this.handleThemeStylesValidOrder()
    },
    handleThemeStylesSecond(themeStylesSecondInfo) {
      let isExist = false
      for (let i = 0; i < this.themeStylesValid.length; i++) {
        if (themeStylesSecondInfo.themeStyleName === this.themeStylesValid[i].themeStyleName) {
          isExist = true
          if (themeStylesSecondInfo.themeStylesSecond&&themeStylesSecondInfo.themeStylesSecond.length > 0&&themeStylesSecondInfo.nextLevelRate) {
            this.themeStylesValid.splice(i, 1, themeStylesSecondInfo)
            this.handleThemeStylesValidOrder()
          } else {
            this.themeStylesValid.splice(i, 1,themeStylesSecondInfo)
            this.handleThemeStylesValidOrder()
            this.handleActivityFormChange()
          }
        }
      }
      // console.log(themeStylesSecondInfo);
      // console.log(this.themeStylesValid);
      if (!isExist && themeStylesSecondInfo.length > 0) {
          this.themeStylesValid.splice(this.themeStylesValid.length, 0, themeStylesSecondInfo)
          this.handleThemeStylesValidOrder()
          this.handleActivityFormChange()
      }
    },
    // 根据首个等级修改其他等级的 额度配置（暂时不需要）
    handleStyleAssignChange(type,submitAssignList,item,data){
      // if(this.$refs.configDetailRef instanceof Array){
      //   if(type==='change'){
      //     this.needTransitions = item
      //     console.log('change',this.needTransitions);
      //     console.log(this.$refs.configDetailRef.length);
      //     this.$refs.configDetailRef.forEach((temItem,index)=>{
      //       if(temItem._props.levelIndex[0]!='0'){
      //         temItem.handleTransitionsChange(item,index)
      //       }
      //     })
      //   }else if(type==='date'){
      //     console.log(this.$refs.configDetailRef);
      //     this.$refs.configDetailRef.forEach((temItem,index)=>{
      //       console.log(temItem);
      //       if(temItem._props.levelIndex[0]!='0'){
      //         temItem.handleChangeAssignDate(item,data)
      //       }
      //     })
      //   }else if(type==='add'){
      //     console.log(this.$refs.configDetailRef);
      //     this.$refs.configDetailRef.forEach((temItem,index)=>{
      //       console.log(temItem);
      //       if(temItem._props.levelIndex[0]!='0'){
      //         temItem.handleSelectDate(item)
      //       }
      //     })
      //   }else if(type==='delete'){
      //     console.log(submitAssignList);
      //     console.log(this.$refs.configDetailRef);
      //     this.$refs.configDetailRef.forEach((temItem,index)=>{
      //       console.log(temItem);
      //       if(temItem._props.levelIndex[0]!='0'){
      //         temItem.handleDeleteAssign(item)
      //       }
      //     })
      //   }
      // }
      // if(type==='init'){
      //   console.log(item);
      //   this.needTransitions = item
      //   this.styleAssignList = []
      //   submitAssignList.forEach(item=>{
      //     let data = {
      //       assignEndTime:item.assignEndTime,
      //       assignItemKey:item.assignItemKey,
      //       assignStartTime:item.assignStartTime,
      //       needTransitions:item.needTransitions,
      //       subAssignList:[]
      //     }
      //     this.styleAssignList.push(data)
      //   })
      // }
      // console.log(item);
    },
    hasRate(item){
      // return true
      return item.nextLevelRate
    },
    handleSubmit(detailItem,valid){
      this.itemCount+=1
      console.log(this.itemCount);
      console.log(detailItem);
      if(!detailItem||Object.keys(detailItem).length==0){
        // console.log('hq-',111111);
        this.$emit("handleSubmit",detailItem,false)
        return
      }
      if(this.btnType==='submit'){
        if(this.$refs.configDetailRef.length>1){
          console.log(detailItem.themeDetail);
          if(!detailItem.themeDetail.nextLevelRate&&!detailItem.themeDetail.isLast){
          //if(this.itemCount<this.$refs.configDetailRef.length&&!detailItem.themeDetail.nextLevelRate){
            //this.$emit("handleInputError")
            // console.log(this.itemCount);
            // console.log(this.$refs.configDetailRef.length);
            // console.log('hq-',222222);
            this.$emit("handleSubmit",detailItem,false,this.configItem.themeChannelName)
          }else {
            this.$emit("handleSubmit",detailItem,valid)
          }
        }else {
          this.$emit("handleSubmit",detailItem,valid)
        }
      }else {
        this.$emit("handleSubmit",detailItem,valid)
      }
      console.log(detailItem);
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #409EFF;
  border-color: #409EFF;
}

::v-deep .el-checkbox__inner:hover,
::v-deep .el-checkbox__input .el-checkbox__inner:focus {
  border-color: #409EFF !important;
}

::v-deep .el-checkbox__input.is-focus .el-checkbox__inner,
::v-deep .el-checkbox__input.is-focus .el-checkbox__inner:hover {
  border-color: #409EFF !important;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #101010;
}

::v-deep .el-checkbox {
  height: 40px;
}

::v-deep .el-form-item {
  .el-form-item__label {
    color: black;
    font-weight: 600;
  }

  .el-form-item__content {
    line-height: 35px !important;
    margin: 3px;
  }
}
::v-deep .el-checkbox__input {
    margin-top: 0px !important;
}
.activity_form_box {
  width: calc(100% - 60px);
  margin-left: 30px;

  .activity_form_item {
    display: flex;
  }
}

.tab_box {
  margin-top: 20px;

  .tab_item_box {
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    border-top-right-radius: 8px;

    .tab_item_context {
      height: 100%;
      width: calc(100% - 40px);
      padding: 20px;
    }
  }
}

::v-deep .el-tabs {
  .el-tabs__nav {
    border: none;
    border-radius: 10px 10px 0px 0px;
  }

  .el-tabs__item.is-active {
    background: rgb(0, 153, 255);
    color: #fff;
  }

  .el-tabs__item {
    min-width: 100px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    height: 42px;
    display: inline-block;
    border: none;
    padding: 0 10px !important;
    background: #fff;
    margin-right: 3px;
    color: black;
    text-align: center;
  }

  .el-tabs__header {
    border-bottom: none;
    margin-bottom: 0;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    border-top-right-radius: 8px;
  }
}

::v-deep  .el-tabs {
  .el-tabs__nav {
    border: none;
    border-radius: 10px 10px 0px 0px;
    display: flex;
    flex-direction: column;
  }

  .el-tabs__item.is-active {
    color: rgb(0, 119, 255);
  }

  .el-tabs__item {
    min-width: 100px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    height: 42px;
    display: inline-block;
    border: none;
    padding: 0px !important;
    background: #fff;
    margin-right: 3px;
    color: black;
    text-align: center;
  }

  .el-tabs__header {
    border-bottom: none;
    margin-bottom: 0;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    border-top-right-radius: 8px;
  }
}
.no_data_tip{
  height: 100px;
  text-align: center;
  vertical-align: middle;
  font-size: 16px;
  margin-top: 80px;
}
</style>
